import { Link } from 'react-router-dom';
import { useLanguage, langPaths } from '@/lib/i18n';

const LOGO_URL = '/logo-transparent.png';

export default function Footer() {
  const { t, lang } = useLanguage();

  return (
    <footer className="border-t border-white/10 py-20 bg-[#0a0f1f]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-start gap-12">
          <div className="space-y-4">
            <div className="flex items-center gap-4">
              <Link to={langPaths[lang]}>
                <img src={LOGO_URL} alt="Skyboard" className="h-[112px] w-auto" data-testid="footer-logo" />
              </Link>
              <img src="https://i.ibb.co/FbRBVGbZ/Captura-de-pantalla-2026-04-18-a-las-23-13-41-gx8nfoyk46p-Mzp-KRSJUXJr2ssu3l-Yv.png" alt="Sitayag" className="h-[80px] w-auto rounded" data-testid="footer-sitayag-logo" />
            </div>
            <p className="text-sm text-gray-400">admin@skyboard.es</p>
            <p className="text-xs text-gray-500 leading-relaxed mt-1">Sitayag SLU · CIF: B45807344 · Plaza Grecia 1, Primera planta, Oficina 1, 45005 Toledo, Castilla-La Mancha, España</p>
          </div>
          <div className="flex flex-col sm:flex-row gap-10">
            <div className="space-y-3">
              <Link to={langPaths[lang]} className="block text-sm text-gray-400 hover:text-white transition-colors" data-testid="footer-home-link">
                {t.nav.home}
              </Link>
              <Link to="/contact" className="block text-sm text-gray-400 hover:text-white transition-colors" data-testid="footer-contact-link">
                {t.nav.contact}
              </Link>
            </div>
            <div className="space-y-3">
              <Link to="/privacy" className="block text-sm text-gray-400 hover:text-white transition-colors" data-testid="footer-privacy-link">
                {t.footer.privacy}
              </Link>
              <Link to="/terms" className="block text-sm text-gray-400 hover:text-white transition-colors" data-testid="footer-terms-link">
                {t.footer.terms}
              </Link>
              <button
                onClick={() => { if (window.__showCookieBanner) window.__showCookieBanner(); }}
                className="block text-sm text-gray-400 hover:text-white transition-colors text-left cursor-pointer"
                data-testid="footer-cookie-settings"
              >
                Cookies
              </button>
              <Link to="/cookies" className="block text-sm text-gray-400 hover:text-white transition-colors" data-testid="footer-cookie-policy-link">
                {lang === 'en' ? 'Cookie Policy' : lang === 'de' ? 'Cookie-Richtlinie' : 'Política de Cookies'}
              </Link>
            </div>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-white/10 text-center">
          <p className="text-sm text-gray-500">&copy; 2026 Skyboard. {t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
}
